import { ItemValidator } from '../ItemValidator';
import { ValidationStatus, ValidationType } from './types';
import { ensureNotUndefined, Item, MenuItem } from '@ael/core-api';
import { List } from 'immutable';

const hasNoSubitems = (item: MenuItem) => {
  return item.childItems.isEmpty();
};

const hasSomeValidChild = (item: MenuItem, items: List<Item>) => {
  return item.childItems.some((itemId: string) => {
    const item = items.find((item: Item) => item.id === itemId);
    ensureNotUndefined(item);
    return ItemValidator.isValid(item);
  });
};

export class MenuItemValidator {
  public static isValid(item: MenuItem, items?: List<Item>) {
    return this.validate(item, items).length === 0;
  }
  public static validate(item: MenuItem, items?: List<Item>): ValidationStatus[] {
    const validations = [];
    const itemName = item.title || 'Unknown title';
    if (!item.title) {
      validations.push({
        type: ValidationType.Error,
        message: 'Missing submenu name.',
        item,
        itemName,
      });
    }

    if (hasNoSubitems(item)) {
      validations.push({
        type: ValidationType.Error,
        message: 'Menu item has no sub-items.',
        item,
        itemName,
      });
    }
    if (items && !hasSomeValidChild(item, items)) {
      validations.push({
        type: ValidationType.Error,
        message:
          'Submenu does not hold any valid items. Make sure there is at least one item with some content inside.',
        item,
        itemName,
      });
    }

    return validations;
  }
}
